var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEncuestas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-customer-survey",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-customer-survey:not(.animated) .animable {opacity: 0;}svg#freepik_stories-customer-survey.animated #freepik--Survey--inject-1 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "elc28uft8crw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "el9s2o9krup3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "elw5uouv1n8zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elot2snf2km3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elmp00fa8kqa8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "eldj2kgd05ean",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "elh8t4783m1hm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el4sj2folkmbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "el66rlpri84bn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxcvvjndj4bc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.78,
    y: 251.67,
    width: 35.1,
    height: 130.73,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "285.33px 317.035px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el69z0uywd9d3"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "273.62 382.4 267.78 382.4 267.78 370.63 279.75 370.63 273.62 382.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "273.765px 376.515px"
    },
    id: "el15wkes3xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el27n1e8h3kky"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.64,
    y: 251.67,
    width: 35.1,
    height: 130.73,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "428.19px 317.035px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elvolbqjhihbk"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elilf0t4qp6jh"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.78,
    y: 251.67,
    width: 147.96,
    height: 126.21,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "341.76px 314.775px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elucx8dkr6po"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrkmft2yo21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 257.26,
    width: 138.89,
    height: 34.61,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "341.755px 274.565px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elr2cs19kswpp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,268h13.12c5.7,0,11.15-4.27,15.07-11.81H320.13C324.05,263.75,329.5,268,335.2,268Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "341.76px 262.095px"
    },
    id: "elpntnrslboal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.9 382.4 415.74 382.4 415.74 370.63 403.77 370.63 409.9 382.4",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "409.755px 376.515px"
    },
    id: "elpc1eiam6t8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc2r0yf12w1d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 297.47,
    width: 138.89,
    height: 34.61,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "341.755px 314.775px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eloeqkmdvcpfo"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,308.22h13.12c5.7,0,11.15-4.27,15.07-11.81H320.13C324.05,304,329.5,308.22,335.2,308.22Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "341.76px 302.315px"
    },
    id: "elch67igxdys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpeoskkz4u7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.31,
    y: 337.67,
    width: 138.89,
    height: 34.61,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "341.755px 354.975px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el8e9lwdt5iaw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.2,348.43h13.12c5.7,0,11.15-4.27,15.07-11.81H320.13C324.05,344.16,329.5,348.43,335.2,348.43Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "341.76px 342.525px"
    },
    id: "elbux2zencmls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg88v4hhkn2r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 86.38,
    width: 134.04,
    height: 135.63,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "145.02px 154.195px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eli160bmlj0yc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluvr8om3sc3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.69,
    y: 86.38,
    width: 140.88,
    height: 135.63,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.13px 154.195px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elve5x9sw61p"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elacgxtrlfbp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 83.11,
    y: 95.56,
    width: 112.03,
    height: 117.27,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "139.125px 154.195px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elli8y3i2qri"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.32,113,116.8,134.56a27.81,27.81,0,0,0,0,39.28l21.52,21.53a1.13,1.13,0,0,0,1.6,0l21.53-21.53a27.81,27.81,0,0,0,0-39.28L139.93,113A1.15,1.15,0,0,0,138.32,113Zm-19.92,59.2a25.54,25.54,0,0,1,0-36.07Zm41.45,0V136.17A25.54,25.54,0,0,1,159.85,172.24Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "139.125px 154.187px"
    },
    id: "elv3a4chhm37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.85 205 331.96 205 327.69 249.22 402.58 249.22 406.85 205",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "367.27px 227.11px"
    },
    id: "eldprry8ytqxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.58 249.22 402.28 251.67 327.38 251.67 327.69 249.22 402.58 249.22",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "364.98px 250.445px"
    },
    id: "el734yur04cpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.55 205 329.66 205 325.38 249.22 400.27 249.22 404.55 205",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "364.965px 227.11px"
    },
    id: "eln909vc8ehun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,246.34,401.89,208a.94.94,0,0,0-.93-1H332.11a.94.94,0,0,0-.94.86L328,246.19a.94.94,0,0,0,.94,1h68.85A.93.93,0,0,0,398.76,246.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.945px 227.095px"
    },
    id: "el4djds91zbyp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.76 249.22 380.46 251.67 297.99 251.67 298.29 249.22 380.76 249.22",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "339.375px 250.445px"
    },
    id: "elul81kfimnjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele4zj4l1bdwb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.09,
    y: 87.88,
    width: 140.63,
    height: 93.49,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "350.405px 134.625px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elozjjoh913pd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elniy30yk7k2n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 87.88,
    width: 140.63,
    height: 93.49,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "347.275px 134.625px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elez84gczxzx6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell7ejk07p1ds"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.84,
    y: 69.91,
    width: 80.88,
    height: 129.41,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "347.28px 134.615px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elzkl5i31y65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el964x9at0r6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.31,
    y: 133.44,
    width: 80.88,
    height: 2.36,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "283.75px 134.62px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "elihi2edkukkj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltee434wce3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.28,
    y: 155.87,
    width: 135.99,
    height: 8.46,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "347.275px 160.1px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el6bbgxygcfiw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.85,77.45h156a.87.87,0,0,1,.86.86h0a.86.86,0,0,1-.86.86h-156a.86.86,0,0,1-.87-.86h0A.87.87,0,0,1,270.85,77.45Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "348.845px 78.31px"
    },
    id: "elq22fmrmngpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,78.31A2.16,2.16,0,1,0,270,76.15,2.16,2.16,0,0,0,267.83,78.31Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "269.99px 78.31px"
    },
    id: "elz5e6z5l7ld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.55,83.15h0A1.17,1.17,0,0,0,420.72,82v-2.5a1.17,1.17,0,0,0-1.17-1.17h0a1.16,1.16,0,0,0-1.16,1.17V82A1.17,1.17,0,0,0,419.55,83.15Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "419.555px 80.74px"
    },
    id: "el2ar9fjobi8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.87,83.15h0A1.18,1.18,0,0,0,285,82v-2.5a1.17,1.17,0,0,0-1.17-1.17h0a1.16,1.16,0,0,0-1.16,1.17V82A1.17,1.17,0,0,0,283.87,83.15Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "283.835px 80.7402px"
    },
    id: "elyars4dbtba9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ely4xq6oize1r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.12,
    y: 78.31,
    width: 144.15,
    height: 90.83,
    style: {
      fill: "rgb(224, 224, 224)",
      opacity: 0.4,
      transformOrigin: "343.195px 123.725px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eluxjf6lh1jse"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.51,78.31a2.16,2.16,0,1,0,2.16-2.16A2.16,2.16,0,0,0,403.51,78.31Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "405.67px 78.31px"
    },
    id: "elayfgephfvm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfnpc57jxkqr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 275.65,
    width: 11.56,
    height: 100.27,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "205.28px 325.785px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elv9wx7ou335m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1wwdy6gos4n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.1,
    y: 375.92,
    width: 132.52,
    height: 6.35,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "140.36px 379.095px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elkb40sxwrkq"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 69.66,
    y: 275.65,
    width: 129.84,
    height: 100.27,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "134.58px 325.785px"
    },
    id: "elci865kv8fqw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.75,
    y: 287.99,
    width: 111.66,
    height: 32.88,
    rx: 7.12,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "134.58px 304.43px"
    },
    id: "el9acyd0nqsz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.75,
    y: 330.69,
    width: 111.66,
    height: 32.88,
    rx: 7.12,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "134.58px 347.13px"
    },
    id: "eloke7ooxkct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,306.69h48.38a2.26,2.26,0,0,0,2.26-2.25h0a2.27,2.27,0,0,0-2.26-2.26H110.39a2.27,2.27,0,0,0-2.26,2.26h0A2.26,2.26,0,0,0,110.39,306.69Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "134.58px 304.435px"
    },
    id: "els3jqfxodpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.39,349.39h48.38a2.26,2.26,0,0,0,2.26-2.25h0a2.27,2.27,0,0,0-2.26-2.26H110.39a2.27,2.27,0,0,0-2.26,2.26h0A2.26,2.26,0,0,0,110.39,349.39Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "134.58px 347.135px"
    },
    id: "eludow0ntkq8p",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Survey--inject-1",
    className: "animable animator-active",
    style: {
      transformOrigin: "209.425px 221.35px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "292.85 101.45 108.05 101.45 122.41 353.12 307.2 353.12 292.85 101.45",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.625px 227.285px"
    },
    id: "el9lqx9ealpxt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.44 101.45 111.64 101.45 126 353.12 310.8 353.12 296.44 101.45",
    style: {
      fill: "current",
      transformOrigin: "211.22px 227.285px"
    },
    id: "elhun0jhfmji4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnstxrqu8fdg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.71,109.91H120.09l11.73,227.81H299.69Z",
    style: {
      opacity: 0.5,
      transformOrigin: "209.89px 223.815px"
    },
    className: "animable",
    id: "elx4b1ramdnvn"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,109.91c12.16,75.94,3.82,151.88,16,227.81H303.94c-12.16-75.93-3.82-151.87-16-227.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "212.015px 223.815px"
    },
    id: "el0o15hr5fhlde",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7o30vykq7k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "155.012px 191.97px"
    },
    className: "animable",
    id: "elfia69vq6qx9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.41,178.17A14.47,14.47,0,0,1,168.75,192a13.14,13.14,0,0,1-13.26,13.69,14.34,14.34,0,0,1-14.21-13.77,13.23,13.23,0,0,1,3.63-9.69,13.05,13.05,0,0,1,9.5-4m-.1-2.89a15.85,15.85,0,0,0-15.93,16.63,17.31,17.31,0,0,0,17.15,16.63,16,16,0,0,0,16.12-16.63,17.47,17.47,0,0,0-17.34-16.63Z",
    style: {
      fill: "current",
      transformOrigin: "155.012px 191.97px"
    },
    id: "el8c004943tyj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,302.92h-53a2.79,2.79,0,0,0-2.82,3.1h0a3.51,3.51,0,0,0,3.41,3.11h53a2.77,2.77,0,0,0,2.8-3.11h0A3.49,3.49,0,0,0,247.22,302.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "221.007px 306.025px"
    },
    id: "el5nu06fc286u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.57,289.87H193.15a2.83,2.83,0,0,0-2.87,3.1h0a3.4,3.4,0,0,0,3.34,3.11H276A2.83,2.83,0,0,0,278.9,293h0A3.39,3.39,0,0,0,275.57,289.87Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "234.589px 292.975px"
    },
    id: "ellj5jklyjuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkjga3t9wcc"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "156.557px 245.735px"
    },
    className: "animable",
    id: "elnzgve64w4an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.1,232a14.26,14.26,0,0,1,14.15,13.77,13.26,13.26,0,0,1-3.69,9.69,13.1,13.1,0,0,1-9.54,4,14.35,14.35,0,0,1-14.24-13.77A13.24,13.24,0,0,1,156.1,232m0-2.9h0a16.09,16.09,0,0,0-16.18,16.63,17.33,17.33,0,0,0,17.22,16.64,16,16,0,0,0,16.05-16.64,17.21,17.21,0,0,0-17.09-16.63Z",
    style: {
      fill: "current",
      transformOrigin: "156.557px 245.735px"
    },
    id: "elyzcotl0ap",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,188.49H189.45a3.25,3.25,0,0,1-3.22-3.11h0a3,3,0,0,1,3-3.1h28.34a3.27,3.27,0,0,1,3.24,3.1h0A3,3,0,0,1,217.8,188.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "203.52px 185.385px"
    },
    id: "elfdqsfgqdunj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.52,188.49h-19.2a3.26,3.26,0,0,1-3.23-3.11h0a3,3,0,0,1,3-3.1h19.21a3.26,3.26,0,0,1,3.23,3.1h0A3,3,0,0,1,250.52,188.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "240.81px 185.385px"
    },
    id: "elc2p15nchv1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,201.54H189.9a3.23,3.23,0,0,1-3.21-3.11h0a3,3,0,0,1,3-3.1h76.09a3.22,3.22,0,0,1,3.2,3.1h0A3,3,0,0,1,266,201.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "227.835px 198.435px"
    },
    id: "elg96sn8wzv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfhknvm9i6ba"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "159.336px 299.499px"
    },
    className: "animable",
    id: "elcihz12c6itc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.27,285.76a15.16,15.16,0,0,1,14.8,13.78,12.65,12.65,0,0,1-3.11,9.68,12.21,12.21,0,0,1-9.26,4,15.44,15.44,0,0,1-15.1-13.77,12.48,12.48,0,0,1,3.26-9.69,12.66,12.66,0,0,1,9.41-4m-.14-2.89A15.2,15.2,0,0,0,142.7,299.5c.77,9.18,9.1,16.63,18.28,16.63s15.76-7.45,15-16.63a18.24,18.24,0,0,0-17.84-16.63Z",
    style: {
      fill: "current",
      transformOrigin: "159.336px 299.499px"
    },
    id: "elws2jj7xkhc",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279,249.13H191.19a3,3,0,0,0-3,3.1h0a3.24,3.24,0,0,0,3.21,3.1h87.85a3,3,0,0,0,3-3.1h0A3.22,3.22,0,0,0,279,249.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "235.22px 252.23px"
    },
    id: "elxdnx6uk475",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.19,236.07H190.81a3,3,0,0,0-3,3.11h0a3.21,3.21,0,0,0,3.19,3.1h67.39a3,3,0,0,0,3-3.1h0A3.2,3.2,0,0,0,258.19,236.07Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "224.6px 239.175px"
    },
    id: "elxth0ekufq69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.93,201.72l-1.18-1.94c-2.59-4.23-8-8-9.86-9.11l1.4-2.48a38.24,38.24,0,0,1,9.68,8.36c4.25-5.71,10.46-11.58,18.87-17.92l1.81,2.34c-9,6.77-15.38,13-19.47,18.93C156.77,200.51,156.35,201.12,155.93,201.72Z",
    style: {
      fill: "current",
      transformOrigin: "160.77px 190.175px"
    },
    id: "elu4kd3kfxcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,255.52c-.39-.65-.79-1.3-1.19-1.94-2.6-4.23-8-8-9.84-9.12l1.42-2.48a38.34,38.34,0,0,1,9.63,8.36c4.26-5.7,10.52-11.58,19.06-17.92l1.77,2.34c-9.12,6.77-15.54,13-19.61,18.93Z",
    style: {
      fill: "current",
      transformOrigin: "162.34px 243.97px"
    },
    id: "elrq2zi4zmi8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.86,309.44l-1.32-1.94c-2.88-4.23-8.46-8-10.38-9.11l1.3-2.48a42.05,42.05,0,0,1,10.09,8.35c3.92-5.7,9.88-11.58,18.16-17.91l1.87,2.34c-8.84,6.77-14.91,13-18.6,18.93Z",
    style: {
      fill: "current",
      transformOrigin: "164.87px 297.895px"
    },
    id: "elguftxfyfuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,129q-2.64,5.76-5.41,11.51a24.75,24.75,0,0,1,13.64,20.08h13.29C244.74,147,236,135.17,224.1,129Z",
    style: {
      fill: "current",
      transformOrigin: "232.155px 144.795px"
    },
    id: "elyqryclvl66q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.47,160.61h13.29A21.17,21.17,0,0,1,196,141.24q-3.88-5.76-7.88-11.52C178.42,136,172.62,147.51,173.47,160.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.694px 145.165px"
    },
    id: "elem60aknmmud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,124.54a32.74,32.74,0,0,0-18,5.18q4,5.76,7.88,11.52a21,21,0,0,1,11.66-3.42,24.25,24.25,0,0,1,11,2.71q2.76-5.76,5.41-11.51A39.2,39.2,0,0,0,206.12,124.54Z",
    style: {
      fill: "current",
      transformOrigin: "206.095px 132.889px"
    },
    id: "eljxk3p52tses",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwkwmoj89rim"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.12,124.54a32.74,32.74,0,0,0-18,5.18q4,5.76,7.88,11.52a21,21,0,0,1,11.66-3.42,24.25,24.25,0,0,1,11,2.71q2.76-5.76,5.41-11.51A39.2,39.2,0,0,0,206.12,124.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      opacity: 0.5,
      transformOrigin: "206.095px 132.889px"
    },
    className: "animable",
    id: "ela8ia7crxj1s"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.36,151.51S208.94,157,207.52,158a3.19,3.19,0,0,0-.57,4.53,3.35,3.35,0,0,0,4.58.87C213,162.34,222.38,151.51,222.36,151.51Zm-14.1,10a1.57,1.57,0,0,1,.28-2.23,1.67,1.67,0,0,1,2.26.43,1.57,1.57,0,0,1-.28,2.23A1.67,1.67,0,0,1,208.26,161.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.308px 157.731px"
    },
    id: "eljtey76yqu68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.27,145.16a4.26,4.26,0,0,1-4.32,4.72,5.25,5.25,0,0,1-5.12-4.72,4.23,4.23,0,0,1,4.28-4.71A5.28,5.28,0,0,1,238.27,145.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "233.549px 145.165px"
    },
    id: "el6fi2g524h5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.42,144.08a.68.68,0,0,1-.68.75.83.83,0,0,1-.82-.75.67.67,0,0,1,.68-.75A.83.83,0,0,1,232.42,144.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "231.669px 144.08px"
    },
    id: "el5awgjt20pni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,144.08a.68.68,0,0,1-.69.75.85.85,0,0,1-.82-.75.67.67,0,0,1,.69-.75A.83.83,0,0,1,236,144.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "235.244px 144.08px"
    },
    id: "elfrlydvaolsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,148h0a4,4,0,0,1-2.67-1.05.37.37,0,0,1,0-.52.36.36,0,0,1,.52,0,3.25,3.25,0,0,0,2.17.86h0a2.66,2.66,0,0,0,2-.84.37.37,0,1,1,.54.51A3.38,3.38,0,0,1,233.77,148Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "233.712px 147.161px"
    },
    id: "elfoc2cmglpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.62,131.1a4.15,4.15,0,0,1-4.2,4.72,5.41,5.41,0,0,1-5.24-4.72,4.1,4.1,0,0,1,4.16-4.71A5.46,5.46,0,0,1,211.62,131.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "206.897px 131.105px"
    },
    id: "elrl77cyss0ie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.74,130a.66.66,0,0,1-.66.75.87.87,0,0,1-.84-.75.65.65,0,0,1,.66-.75A.86.86,0,0,1,205.74,130Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.989px 130px"
    },
    id: "el0eva9m2flkz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.31,130a.66.66,0,0,1-.67.75.88.88,0,0,1-.84-.75.66.66,0,0,1,.67-.75A.87.87,0,0,1,209.31,130Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.555px 130px"
    },
    id: "elsfdppqtcchc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.41,133h-4.68a.38.38,0,0,1,0-.75h4.68a.38.38,0,0,1,0,.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "207.07px 132.625px"
    },
    id: "el6ws9g936gwo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.87,145.16a4.26,4.26,0,0,1-4.32,4.72,5.25,5.25,0,0,1-5.12-4.72,4.23,4.23,0,0,1,4.28-4.71A5.29,5.29,0,0,1,187.87,145.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "183.149px 145.165px"
    },
    id: "el1bt8oelxmfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,144.08a.68.68,0,0,1-.68.75.83.83,0,0,1-.82-.75.67.67,0,0,1,.68-.75A.83.83,0,0,1,182,144.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.249px 144.08px"
    },
    id: "elc87ajjs28ss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.58,144.08a.67.67,0,0,1-.68.75.85.85,0,0,1-.82-.75.67.67,0,0,1,.68-.75A.82.82,0,0,1,185.58,144.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.83px 144.08px"
    },
    id: "elnuaw740t83k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,148a.35.35,0,0,1-.25-.1.37.37,0,0,1,0-.52,3.43,3.43,0,0,1,2.53-1.08,4,4,0,0,1,2.67,1.06.36.36,0,0,1,0,.52.39.39,0,0,1-.53,0,3.2,3.2,0,0,0-2.18-.86,2.68,2.68,0,0,0-2,.83A.39.39,0,0,1,181,148Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "183.352px 147.15px"
    },
    id: "el5zjffe6b35k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,110.56c-3.12-6.57-10.4-10.92-18.25-10.92h-16a6.24,6.24,0,0,1-5.55-2.9c-2.23-4.18-7.55-7.16-13.59-7.16s-11,3-12.76,7.16c-.73,1.76-2.82,2.9-5.22,2.9h-16c-7.85,0-14.64,4.35-17,10.92a1.62,1.62,0,0,0-.1.72,2,2,0,0,0,2,1.9H255.15A1.79,1.79,0,0,0,256.74,110.56ZM204,101.45A4.78,4.78,0,0,1,199.33,97a4.16,4.16,0,0,1,4.2-4.45A4.77,4.77,0,0,1,208.24,97,4.16,4.16,0,0,1,204,101.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.604px 101.38px"
    },
    id: "elesk7fy0pjv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "329.97px 264.56px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.42,409.11a3.2,3.2,0,0,1-2.22-.55.69.69,0,0,1-.07-.76.74.74,0,0,1,.51-.41c1.18-.33,3.91,1.13,4,1.2a.17.17,0,0,1,.1.18.15.15,0,0,1-.12.14A12.92,12.92,0,0,1,360.42,409.11Zm-1.32-1.42a1.11,1.11,0,0,0-.33,0,.45.45,0,0,0-.32.24c-.1.22,0,.33,0,.39.4.47,2.26.48,3.6.29A8.65,8.65,0,0,0,359.1,407.69Z",
    style: {
      fill: "current",
      transformOrigin: "360.395px 408.238px"
    },
    id: "eloda0q9726we",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,408.91h-.07c-.93-.4-2.87-2-2.83-2.82,0-.2.12-.44.6-.49a1.42,1.42,0,0,1,1,.3,5.65,5.65,0,0,1,1.46,2.83.18.18,0,0,1,0,.16A.17.17,0,0,1,362.62,408.91Zm-2.13-3h-.1c-.31,0-.32.15-.32.19,0,.5,1.31,1.75,2.28,2.29a4.66,4.66,0,0,0-1.23-2.26A1,1,0,0,0,360.49,405.93Z",
    style: {
      fill: "current",
      transformOrigin: "361.259px 407.258px"
    },
    id: "elv70ws0b9q88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.68 408.74 363.33 408.74 360.7 391.72 368.05 391.72 370.68 408.74",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "365.69px 400.23px"
    },
    id: "eluccw9f9khl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,407.89h8a.74.74,0,0,1,.68.5l2.18,6.53a1,1,0,0,1-.91,1.3c-2.9,0-7.1-.21-10.74-.21-4.25,0-3.87.23-8.86.23-3,0-4.19-3.05-3-3.33,5.61-1.25,6.26-1.39,10.88-4.45A3.09,3.09,0,0,1,363.28,407.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "362.18px 412.065px"
    },
    id: "elbpib78eo7qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzeolqnm0dg"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "360.7 391.73 362.06 400.5 369.41 400.5 368.05 391.73 360.7 391.73",
    style: {
      opacity: 0.2,
      transformOrigin: "365.055px 396.115px"
    },
    className: "animable",
    id: "el3j1u4d5d9lc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.84,225.45l-5,5.05,7.66,2.71s3-4.12.89-6.94Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "369.491px 229.33px"
    },
    id: "elqsrifuxnwo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.16 237.56 370.81 238.68 372.52 233.21 364.86 230.5 363.16 237.56",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "367.84px 234.59px"
    },
    id: "elalbslwha4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.18,163.27c.65,1.4,1.17,2.59,1.69,3.89s1,2.55,1.5,3.83c.95,2.57,1.8,5.19,2.59,7.84a82.8,82.8,0,0,1,2,8.15l.38,2.1.31,2.14c.11.71.18,1.45.24,2.18s.16,1.39.16,2.31l0,1.3,0,1.15-.06,1.13-.11,1.07c-.13,1.44-.32,2.79-.5,4.16-.4,2.7-.86,5.34-1.37,8-1.06,5.23-2.22,10.34-3.62,15.49l-9.11-1.8c.58-5.08,1.18-10.24,1.66-15.32.23-2.54.48-5.07.62-7.55.06-1.22.13-2.46.13-3.63v-.88l0-.81,0-.81-.07-.66a15,15,0,0,0-.22-1.57c-.09-.56-.17-1.12-.3-1.69l-.37-1.71-.43-1.72c-.62-2.3-1.32-4.61-2.12-6.92s-1.69-4.61-2.63-6.89c-.46-1.15-.94-2.29-1.44-3.41s-1-2.29-1.49-3.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.335px 195.64px"
    },
    id: "elwruq1pwn6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.65,221.87s1.22,56.24,4.52,78.64c3.44,23.3,16,98.29,16,98.29h12.44s-4.46-71.37-5.88-94.3c-1.55-25-1.21-82.63-1.21-82.63Z",
    style: {
      fill: "current",
      transformOrigin: "355.13px 310.335px"
    },
    id: "el85uamvnmy06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.18,393.84c-.06,0,1.28,5.17,1.28,5.17H372.6l-.11-4.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.389px 396.425px"
    },
    id: "elf3db7b33dzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldnc91kt5ek4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.11,
    cy: 130.65,
    rx: 1.13,
    ry: 0.74,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.11px 130.65px",
      transform: "rotate(-86.48deg)"
    },
    className: "animable",
    id: "elfosam1kkq77"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M335.54,131.78a23.2,23.2,0,0,1-3.16,5.32,3.52,3.52,0,0,0,2.95.56Z",
    style: {
      fill: "rgb(237, 132, 126)",
      transformOrigin: "333.96px 134.776px"
    },
    id: "elu9j7dhzs38n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,127.2a.43.43,0,0,1-.22-.06,2.82,2.82,0,0,0-2.57-.48.36.36,0,0,1-.47-.21.37.37,0,0,1,.23-.47,3.55,3.55,0,0,1,3.26.56.37.37,0,0,1,.07.51A.38.38,0,0,1,338.18,127.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.726px 126.503px"
    },
    id: "elkv2x3q25cz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.3,137.52c-1.24,5.38-2.64,15.23,1,18.81,0,0-1.66,5.45-11.65,5.45-11,0-5.05-5.45-5.05-5.45,6-1.43,6.05-5.87,5.15-10.05Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "347.147px 149.65px"
    },
    id: "elq3nvq8e4cg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.17,158.85c1.08-2.19,2.27-4.71,0-5.49-2.48-.87-16.19-1.75-21-.13a5,5,0,0,0-3.61,6.08Z",
    style: {
      fill: "current",
      transformOrigin: "348.434px 155.818px"
    },
    id: "el7r2pcpilg54",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,158.44c6.33,2.92,9.55,25.06,9.55,25.06l-12.75,4a129.49,129.49,0,0,1-5.53-18C360,160.26,364.21,155.46,370.69,158.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "370.858px 172.529px"
    },
    id: "el8d74t87x6kf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.33,192.89l-5.88-5.06-5.29,7.7s4.75,3.81,10,2.25Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "286.745px 192.993px"
    },
    id: "el9k5ebdh2luv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.7 185.38 277.89 192.99 281.16 195.53 286.45 187.83 278.7 185.38",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "282.17px 190.455px"
    },
    id: "elf6i8nqrnllp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.65,129.33c-.74,7.64-.79,12.14-4.79,16.06A10,10,0,0,1,335,140.16c-1.4-6.86,0-18.2,7.63-21.24A10.09,10.09,0,0,1,356.65,129.33Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "345.617px 133.19px"
    },
    id: "ellc8fp6u41i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,131.78c-.67-5.28-.56-7.28,2.26-8.45-2.93-.58-5.47-.66-6.68-2.37s-1.5-6.08,4.38-8.08c-.54,1,1.17,3.08,6.58,1.2s13.29-2.08,14,3.42c2.86-1,7.65,7.83,2,14.28-4.71,5.4-7.85,9.13-8.78,12a1,1,0,0,1-1.37.6c-1.95-.91-5.44-.13-7,.29a1,1,0,0,1-1.14-.51C344.24,142.08,341.51,136.14,341,131.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "351.02px 128.791px"
    },
    id: "elrl4hblot8vi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.48,118.17s2.32-3.27,6.77-.84A20.16,20.16,0,0,0,360.48,118.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.865px 117.301px"
    },
    id: "el8fv2ga97dn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.86,118.87s3.23-2,.71-5.77A14.53,14.53,0,0,1,360.86,118.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.696px 115.985px"
    },
    id: "elspja6t0sz4h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.74,132a9.15,9.15,0,0,1-2.68,4.95c-1.85,1.75-3.45.51-3.5-1.74-.05-2,.85-5.38,3-6.28S345.12,129.74,344.74,132Z",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "341.68px 133.231px"
    },
    id: "elrwfourtzlla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elogk42h1bp9n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.68,253.12c.72,16.78,1.85,36.26,3.49,47.39.63,4.24,1.55,10.18,2.65,17.07C350.24,293.46,352.88,262.38,339.68,253.12Z",
    style: {
      opacity: 0.3,
      transformOrigin: "344.552px 285.35px"
    },
    className: "animable",
    id: "elps0h967zs38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.17,409.11c-.94,0-1.85-.13-2.14-.55a.68.68,0,0,1,0-.76,1,1,0,0,1,.57-.41c1.23-.33,3.75,1.13,3.86,1.2a.15.15,0,0,1,.07.18.18.18,0,0,1-.14.14A13.43,13.43,0,0,1,334.17,409.11Zm-1.11-1.42a1.18,1.18,0,0,0-.34,0,.53.53,0,0,0-.35.24c-.13.22-.09.33-.05.39.33.47,2.18.48,3.56.29A7.61,7.61,0,0,0,333.06,407.69Z",
    style: {
      fill: "current",
      transformOrigin: "334.226px 408.226px"
    },
    id: "elv7cfro33xai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.4,408.91h-.07c-.87-.4-2.58-2-2.41-2.82,0-.2.18-.44.66-.49a1.29,1.29,0,0,1,1,.3c.91.77,1,2.75,1,2.83a.21.21,0,0,1-.08.16A.19.19,0,0,1,336.4,408.91Zm-1.69-3h-.1c-.32,0-.34.15-.35.19-.1.5,1.05,1.75,1.94,2.29a4,4,0,0,0-.89-2.26A.92.92,0,0,0,334.71,405.93Z",
    style: {
      fill: "current",
      transformOrigin: "335.244px 407.25px"
    },
    id: "elv0c4wzsxo3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.48 408.74 337.14 408.74 337 391.72 344.35 391.72 344.48 408.74",
    style: {
      fill: "rgb(255, 195, 189)",
      transformOrigin: "340.74px 400.23px"
    },
    id: "el8fdmavyod0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.21,407.89h8a.6.6,0,0,1,.6.5l1.23,6.53a1.11,1.11,0,0,1-1.11,1.3c-2.89,0-7.07-.21-10.7-.21-4.26,0-7.94.23-12.93.23-3,0-3.74-3.05-2.47-3.33,5.79-1.25,10.49-1.39,15.56-4.45A3.57,3.57,0,0,1,337.21,407.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.146px 412.065px"
    },
    id: "eljh2o9jyfur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnbdrd4p7uu9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "337.01 391.73 337.07 400.5 344.42 400.5 344.36 391.73 337.01 391.73",
    style: {
      opacity: 0.2,
      transformOrigin: "340.715px 396.115px"
    },
    className: "animable",
    id: "elz9xcppkg1m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.54,221.87s-3,54.93-2.94,77.33c0,23.3,11.8,99.6,11.8,99.6h12.44S343.6,323.86,345,301c1.49-25,8.71-79.11,8.71-79.11Z",
    style: {
      fill: "current",
      transformOrigin: "338.155px 310.335px"
    },
    id: "eldjjkbgw2stk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,393.84c-.06,0,.51,5.17.51,5.17h15.14l.58-4.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.293px 396.425px"
    },
    id: "ele7ypdz92168",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.22,158.37s-12.52,31.63-7.07,86.3h45.72c.48-6-4.3-58.26,2.52-86.68a101.36,101.36,0,0,0-13.1-1.66,145.28,145.28,0,0,0-16.7,0A74.84,74.84,0,0,0,328.22,158.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "344.583px 200.38px"
    },
    id: "elwan3y30o8ua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliabs3ighgm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.75,187c-.68,5-1.24,10.71-1.6,17,8.88-8.16,11.92-28.49,11.92-28.49Z",
    style: {
      opacity: 0.2,
      transformOrigin: "326.11px 189.755px"
    },
    className: "animable",
    id: "elg89qozlrh98"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.93,173.43c-1.8,4.68-3.62,9.19-5.62,13.72s-4.07,9-6.4,13.48L320,202.3l-.46.84c-.19.34-.17.36-.69,1.23a9.78,9.78,0,0,1-3.61,3.36,10.76,10.76,0,0,1-3.91,1.18,16.46,16.46,0,0,1-5.6-.45,31,31,0,0,1-4.24-1.38,55.15,55.15,0,0,1-7.17-3.6c-1.13-.65-2.21-1.35-3.28-2S289,200,287.85,199.2l5.4-8.28a70.26,70.26,0,0,0,12.15,5.27,18.34,18.34,0,0,0,2.73.62,3.84,3.84,0,0,0,1.6,0c.06,0-.13-.06-.46.11a2.69,2.69,0,0,0-1,.88c-.21.35.06-.17.15-.37l.36-.79.72-1.57c1.9-4.24,3.66-8.63,5.37-13s3.37-8.93,4.9-13.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.39px 188.854px"
    },
    id: "el5cnsvb05bni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.9,161.69c2.34,6.54-14.22,32.87-14.22,32.87l-9.82-9.73s2.51-8.27,5.82-18.23C322.94,156.81,335.67,155.44,337.9,161.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "325.993px 176.229px"
    },
    id: "elh583l6xn4t",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEncuestas);
export default __webpack_public_path__ + "static/media/encuestas.59e7a8d5.svg";
export { ForwardRef as ReactComponent };